//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            shippingTypes: null
        };
    },
    created: function created() {
        var _this = this;

        new Form().get('/api/cart/shipping').then(function (shippingTypes) {
            _this.shippingTypes = shippingTypes;
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}],"syntax-dynamic-import"]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/templates/semperit/assets/js/modules/checkout/components/shipping-type/components/ShippingType.vue
// module id = C6uP
// module chunks = 4